export const RATE_VIEWER_LOAD_RATES = 'RATE_VIEWER_LOAD_RATES';
export const loadRates = (rateViewerKey, model) => ({
  type: RATE_VIEWER_LOAD_RATES,
  rateViewerKey,
  model,
});

export const RATE_VIEWER_SELECT_RATE = 'RATE_VIEWER_SELECT_RATE';
export const selectRate = (rateViewerKey, selectedRate) => ({
  type: RATE_VIEWER_SELECT_RATE,
  rateViewerKey,
  selectedRate,
});

export const RATE_VIEWER_SELECT_SELLER_PROVIDER = 'RATE_VIEWER_SELECT_SELLER_PROVIDER';
export const selectSellerProvider = (rateViewerKey, sellerProviderId) => ({
  type: RATE_VIEWER_SELECT_SELLER_PROVIDER,
  rateViewerKey,
  sellerProviderId,
});

export const RATE_VIEWER_START_LOADING_RATES = 'RATE_VIEWER_START_LOADING_RATES';
export const startLoadingRates = (rateViewerKey, jobGuid, rates) => ({
  type: RATE_VIEWER_START_LOADING_RATES,
  rateViewerKey,
  jobGuid,
  rates,
});

export const RATE_VIEWER_START_LOADING_RATES_ERROR = 'RATE_VIEWER_START_LOADING_RATES_ERROR';
export const startLoadingRatesError = (rateViewerKey, errors) => ({
  type: RATE_VIEWER_START_LOADING_RATES_ERROR,
  rateViewerKey,
  errors,
});

export const RATE_VIEWER_ON_RATE_RECIEVED_ERROR_PRE = 'RATE_VIEWER_ON_RATE_RECIEVED_ERROR_PRE';
export const onRatesRecievedErrorPre = (jobGuid, errorPayload) => ({
  type: RATE_VIEWER_ON_RATE_RECIEVED_ERROR_PRE,
  jobGuid,
  errorPayload,
});

export const RATE_VIEWER_ON_RATE_RECIEVED_ERROR = 'RATE_VIEWER_ON_RATE_RECIEVED_ERROR';
export const onRatesRecievedError = (rateViewerKey, providerRateError) => ({
  type: RATE_VIEWER_ON_RATE_RECIEVED_ERROR,
  rateViewerKey,
  providerRateError,
});

export const RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS_PRE = 'RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS_PRE';
export const onRatesRecievedSuccessPre = (jobGuid, data) => ({
  type: RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS_PRE,
  jobGuid,
  data,
});

export const RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS = 'RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS';
export const onRatesRecievedSuccess = (rateViewerKey, providerRate) => ({
  type: RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS,
  rateViewerKey,
  providerRate,
});

export const RATE_VIEWER_CLEAR = 'RATE_VIEWER_CLEAR';
export const clearRateViewer = (rateViewerKey) => ({
  type: RATE_VIEWER_CLEAR,
  rateViewerKey,
});

export const RATE_VIEWER_CLEAR_ERROR = 'RATE_VIEWER_CLEAR_ERROR';
export const clearRateViewerError = (rateViewerKey) => ({
  type: RATE_VIEWER_CLEAR_ERROR,
  rateViewerKey,
});
